"use strict";
checkList.classy.controller({
    name: 'TaxesNotVerifiedController',
    inject: ['$scope', 'ApplicationService', 'SchoolModelService', '$sce', 'TaxEmailModelFactory', '$modal'],
    init: function ()
    {
        this.$.ApplicationService = this.ApplicationService;
        this.$.$sce = this.$sce;
        this.$.schoolinfo = this.SchoolModelService.get()[0];
        this.$.familyNo = this.ApplicationService.getFamilyNo();
        //this.$.setAnswer(76);
    },
    conversion: function(note)
    {
        if (this.$.schoolinfo.School_Country == "CAN") {
                note = note.replace("Federal", "T1 General")
                            .replace("State", "Provincial")
                            .replace("W2 Tax", "T4 Slips")
                            .replace("W2", "T4 Slips")
                            .replace("Form 1065 or 1120s", "CRA Notice of Assessment");
        }
        return note;
    },
    displayEmail: function(note)
    {
        var self = this;
        return this.$modal.open({
            templateUrl: "fast/submodules/schoolside/applications/submodules/applicationOverview/submodules/taxes/partials/taxEmailModal.html",
            controller: 'TaxEmailModalController',
            resolve: {
                email: function()
                {
                    var model = new self.TaxEmailModelFactory(self.ApplicationService.getFamilyID());
                    return model.resolveData(note.split("-")[1]);
                }
            }
        });
    }
});
